<template>
    <div>
        <v-overlay :value="isProcessing">
            <v-progress-circular
                indeterminate
                color="primary"
                :size="70"
                :width="7"
            ></v-progress-circular>
        </v-overlay>
        <v-dialog v-model="showSuccess" width="500">
            <v-card class="parent-member-modal">
                <h1>Request sent</h1>
                <p class="wrap">A request was sent to {{toEmail}}.</p>
                <p>You'll receive notice via email once your account is activated.</p>
                <v-btn v-on:click="returnHome()">RETURN HOME</v-btn>
            </v-card>
        </v-dialog>
        <v-row justify="center">
            <v-col class="parent-member" lg="8" md="10" sm="10">
                <h1>Send a Parent/Guardian request to activate your Junior ASCA Membership</h1>
                <p>Enter your Parent/Guardian Member ID Or email to have an email request sent on your behalf.</p>
                <p>You will not be able to access your Junior ASCA Membership until the request is approved.</p>

                <div id="input-container">
                    <v-text-field
                        outlined
                        placeholder="Parent/Guardian Member ID"
                        type="text"
                        v-model="memberId"
                    />
                    <p id="or-text">- OR -</p>
                    <v-text-field
                        outlined
                        placeholder="Parent/Guardian Email"
                        type="email"
                        v-model="memberEmail"
                        :error-messages="validEmail == null || validEmail ? null : ['Email must be valid']"
                    />
                    <v-alert
                        width="100%"
                        v-if="!!errorMessage"
                        dismissible
                        type="error"
                    >{{ errorMessage }}</v-alert>
                </div>
                <v-btn
                    :dark="isValid()"
                    large
                    color="primary"
                    v-on:click="submit()"
                    :disabled="!isValid()"
                >SEND REQUEST</v-btn>

                <div class="footer-container">
                    <v-img height="2rem" contain src="../../../assets/logo.svg" />
                    <footer-text />
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { debounce } from "throttle-debounce";

import FooterText from '../../../components/common/FooterText.vue';

import validateEmail from '@/helpers/validate-email';
import authenticationService from "../../../services/authenticationService";
import { getErrorMessage } from '@/services/errorHandler';

export default Vue.extend({
    components: { FooterText },
    name: 'ParentMember',
    data() {
        return {
            showSuccess: false,
            isError: false,
            isProcessing: false,
            errorMessage: '',

            memberId: '',
            memberEmail: '',
            validEmail: null,

            toEmail: '',
        }
    },
    methods: {
        submit: async function() {
            this.isProcessing = true;

            try {
                if (!!this.memberEmail && !validateEmail(this.memberEmail)) {
                    (this.validEmail as any) = false;
                    return;
                }

                const data = this.$store.state.parentVerification;

                const response = await authenticationService.sendActivationRequest({
                    email: this.memberEmail,
                    memberId: this.memberId,
                    juniorId: data.juniorId,
                    firstName: data.firstName,
                    lastName: data.lastName,
                });

                this.errorMessage = '';

                if (response.sent) {
                    this.showSuccess = true;
                    this.toEmail = response.to;
                } else this.errorMessage = response.errors ? response.errors.join(',') : 'An Unknown Error Occured';
            } catch (error) {
                this.errorMessage = getErrorMessage(error);
                this.isError = true;
            } finally {
                this.isProcessing = false;
            }
        },
        returnHome() {
            this.showSuccess = false;
            this.$router.push('/login');
        },
        isValid() {
            return !!this.memberId || this.validEmail;
        },
    },
    watch: {
        memberEmail: {
            handler: debounce(
                500,
                function (this: any, newVal: string, oldVal: string) {
                    if (newVal === oldVal || !newVal) return;

                    if (!newVal) this.validEmail = null;
                    else this.validEmail = validateEmail(newVal);
                }
            ),
            deep: true,
        },
    }
});
</script>
